import { useRef } from "react";
import { useIntersection } from "react-use";

export type ElementInViewState = "visible" | "obscured" | "hidden";

const defaultIntersectionObserverInit = {
  root: null,
  rootMargin: "0px",
  threshold: 1,
};

export default function useElementInView<T extends HTMLElement>(
  options?: IntersectionObserverInit
): [React.RefObject<T>, ElementInViewState] {
  const intersectionRef = useRef<T>(null);
  const intersection = useIntersection(intersectionRef, {
    ...defaultIntersectionObserverInit,
    ...options,
  });

  let state: ElementInViewState = "hidden";

  if (intersection && intersection.intersectionRatio === 0) {
    state = "hidden";
  } else if (intersection && intersection.intersectionRatio < 1) {
    state = "obscured";
  } else if (intersection) {
    state = "visible";
  }

  return [intersectionRef, state];
}
